define(["react","prop-types","underscore","react-bootstrap"], function(__WEBPACK_EXTERNAL_MODULE__3__, __WEBPACK_EXTERNAL_MODULE__4__, __WEBPACK_EXTERNAL_MODULE__10__, __WEBPACK_EXTERNAL_MODULE__24__) { return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 59);
/******/ })
/************************************************************************/
/******/ ({

/***/ 10:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__10__;

/***/ }),

/***/ 24:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__24__;

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__3__;

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__4__;

/***/ }),

/***/ 59:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(60);


/***/ }),

/***/ 60:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  version: true
};
Object.defineProperty(exports, "version", {
  enumerable: true,
  get: function get() {
    return _package.version;
  }
});

var _package = __webpack_require__(61);

var _controls = __webpack_require__(62);

Object.keys(_controls).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _controls[key];
    }
  });
});

/***/ }),

/***/ 61:
/***/ (function(module) {

module.exports = JSON.parse("{\"name\":\"@bingads-webui-react/primitive-unthemed\",\"description\":\"Please find documentation and tutorial at http://bingadsinternal.azurewebsites.net/sharedcomponents/client-react-controls/jsdoc/primitive-unthemed\",\"version\":\"1.6.6\",\"main\":\"dist/index\",\"license\":\"UNLICENSED\",\"peerDependencies\":{\"prop-types\":\"15.6.0\",\"react\":\"16.3.0\",\"react-dom\":\"16.3.0\",\"react-bootstrap\":\"0.32.3\",\"underscore\":\"*\"},\"devDependencies\":{\"@bingads-webui-react/primitive-unthemed\":\"file:.\",\"@bingads-webui-react/react-test-setup\":\">=1.0.0\",\"@bingads-webui-test/iframe-driver\":\">=2.1.0\",\"@bingads-webui-react/layout\":\">=1.0.0\",\"chai\":\"3.5.0\",\"enzyme\":\"3.3.0\",\"jquery\":\"2.2.4\",\"react-hot-loader\":\"3.1.3\"}}");

/***/ }),

/***/ 62:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Accordion", {
  enumerable: true,
  get: function get() {
    return _reactBootstrap.Accordion;
  }
});
Object.defineProperty(exports, "Alert", {
  enumerable: true,
  get: function get() {
    return _reactBootstrap.Alert;
  }
});
Object.defineProperty(exports, "Label", {
  enumerable: true,
  get: function get() {
    return _reactBootstrap.ControlLabel;
  }
});
Object.defineProperty(exports, "Radio", {
  enumerable: true,
  get: function get() {
    return _reactBootstrap.Radio;
  }
});
Object.defineProperty(exports, "Checkbox", {
  enumerable: true,
  get: function get() {
    return _reactBootstrap.Checkbox;
  }
});
Object.defineProperty(exports, "Dropdown", {
  enumerable: true,
  get: function get() {
    return _reactBootstrap.Dropdown;
  }
});
Object.defineProperty(exports, "DropdownButton", {
  enumerable: true,
  get: function get() {
    return _reactBootstrap.DropdownButton;
  }
});
Object.defineProperty(exports, "MenuItem", {
  enumerable: true,
  get: function get() {
    return _reactBootstrap.MenuItem;
  }
});
Object.defineProperty(exports, "Modal", {
  enumerable: true,
  get: function get() {
    return _reactBootstrap.Modal;
  }
});
Object.defineProperty(exports, "Overlay", {
  enumerable: true,
  get: function get() {
    return _reactBootstrap.Overlay;
  }
});
Object.defineProperty(exports, "OverlayTrigger", {
  enumerable: true,
  get: function get() {
    return _reactBootstrap.OverlayTrigger;
  }
});
Object.defineProperty(exports, "Tooltip", {
  enumerable: true,
  get: function get() {
    return _reactBootstrap.Tooltip;
  }
});
Object.defineProperty(exports, "Popover", {
  enumerable: true,
  get: function get() {
    return _reactBootstrap.Popover;
  }
});
Object.defineProperty(exports, "Nav", {
  enumerable: true,
  get: function get() {
    return _reactBootstrap.Nav;
  }
});
Object.defineProperty(exports, "NavDropdown", {
  enumerable: true,
  get: function get() {
    return _reactBootstrap.NavDropdown;
  }
});
Object.defineProperty(exports, "NavItem", {
  enumerable: true,
  get: function get() {
    return _reactBootstrap.NavItem;
  }
});
Object.defineProperty(exports, "Tabs", {
  enumerable: true,
  get: function get() {
    return _reactBootstrap.Tabs;
  }
});
Object.defineProperty(exports, "Tab", {
  enumerable: true,
  get: function get() {
    return _reactBootstrap.Tab;
  }
});
Object.defineProperty(exports, "Image", {
  enumerable: true,
  get: function get() {
    return _reactBootstrap.Image;
  }
});
exports.TextArea = exports.Select = exports.Navbar = exports.Carousel = exports.Glyphicon = exports.Input = exports.Button = void 0;

var _underscore = _interopRequireDefault(__webpack_require__(10));

var _react = _interopRequireDefault(__webpack_require__(3));

var _propTypes = _interopRequireDefault(__webpack_require__(4));

var _reactBootstrap = __webpack_require__(24);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

const Button = _react.default.forwardRef((props, ref) => {
  const btnStyle = props.btnStyle,
        className = props.className,
        other = _objectWithoutProperties(props, ["btnStyle", "className"]);

  let bsStyle = btnStyle;
  let btnClasses = className; // For CommandBar button style, add btn-command class

  if (btnStyle === 'command') {
    const btnClass = ['btn-command'];
    btnClass.push(btnClasses);
    btnClasses = className ? btnClass.join(' ') : btnClass.join('');
    bsStyle = 'default';
  }

  return _react.default.createElement(_reactBootstrap.Button, _extends({}, other, {
    bsStyle: bsStyle,
    className: btnClasses,
    ref: ref
  }));
});

exports.Button = Button;
Button.propTypes = {
  btnStyle: _propTypes.default.string,
  className: _propTypes.default.string
};
Button.defaultProps = {
  btnStyle: undefined,
  className: undefined
};

const Glyphicon = _react.default.forwardRef((props, ref) => {
  const iconStyle = props.iconStyle,
        className = props.className,
        glyph = props.glyph,
        bsClass = props.bsClass,
        other = _objectWithoutProperties(props, ["iconStyle", "className", "glyph", "bsClass"]);

  let iconGlyph = glyph;
  let iconBsClass = bsClass;
  let iconClasses = className; // For bingads specific icons (such as ba-chart), trim ba- in glyph prop and add custom bsClass

  if (iconGlyph && iconGlyph.indexOf('ba-') === 0) {
    const bsClasses = ['iconba'];
    bsClasses.push(iconBsClass);
    iconBsClass = bsClasses.join(' ');
    iconGlyph = iconGlyph.substr(3);
  }

  if (iconStyle) {
    const iconClass = ['icon-'];
    iconClass[0] += iconStyle;
    iconClass.push(iconClasses);
    iconClasses = className ? iconClass.join(' ') : iconClass.join('');
  } else {
    iconClasses = className;
  }

  if (iconClasses) {
    iconClasses = iconClasses.trim();
  }

  return _react.default.createElement(_reactBootstrap.Glyphicon, _extends({}, other, {
    bsClass: iconBsClass,
    className: iconClasses,
    glyph: iconGlyph,
    ref: ref
  }));
});

exports.Glyphicon = Glyphicon;
Glyphicon.propTypes = {
  bsClass: _propTypes.default.string,
  className: _propTypes.default.string,
  glyph: _propTypes.default.string.isRequired,
  iconStyle: _propTypes.default.string
};
Glyphicon.defaultProps = {
  bsClass: undefined,
  className: undefined,
  iconStyle: undefined
};

const Input = _react.default.forwardRef((props, ref) => {
  const isStatic = props.isStatic,
        staticDisplay = props.staticDisplay,
        rest = _objectWithoutProperties(props, ["isStatic", "staticDisplay"]);

  return isStatic ? _react.default.createElement(_reactBootstrap.FormControl.Static, _extends({
    componentClass: "span"
  }, rest, {
    type: rest.type,
    ref: ref
  }), staticDisplay(props.value)) : _react.default.createElement(_reactBootstrap.FormControl, _extends({}, rest, {
    type: rest.type,
    ref: ref
  }));
});

exports.Input = Input;
Input.propTypes = {
  isStatic: _propTypes.default.bool,
  staticDisplay: _propTypes.default.func,
  type: _propTypes.default.string,
  value: _propTypes.default.string
};
Input.defaultProps = {
  isStatic: false,
  staticDisplay: _underscore.default.identity,
  type: 'text',
  value: undefined
};

const Navbar = _react.default.forwardRef((props, ref) => {
  const navStyle = props.navStyle,
        className = props.className,
        other = _objectWithoutProperties(props, ["navStyle", "className"]);

  let navClasses = className;

  if (navStyle === 'default') {
    const navClass = ['default-toolbar'];
    navClass.push(navClasses);
    navClasses = className ? navClass.join(' ') : navClass.join('');
  }

  if (navStyle === 'primary') {
    const navClass = ['primary-toolbar'];
    navClass.push(navClasses);
    navClasses = className ? navClass.join(' ') : navClass.join('');
  }

  return _react.default.createElement(_reactBootstrap.Navbar, _extends({}, other, {
    className: navClasses,
    ref: ref
  }), props.children);
});

exports.Navbar = Navbar;
Navbar.propTypes = {
  children: _propTypes.default.node,
  className: _propTypes.default.string,
  navStyle: _propTypes.default.string
};
Navbar.defaultProps = {
  children: null,
  className: undefined,
  navStyle: 'default'
};
Navbar.Brand = _reactBootstrap.Navbar.Brand;

class Carousel extends _react.default.Component {
  constructor(props) {
    super(props);

    _defineProperty(this, "handlePause", e => {
      e.preventDefault();
      this.carouselRef.current.pause();
    });

    _defineProperty(this, "handlePlay", e => {
      e.preventDefault();
      this.carouselRef.current.play();
    });

    this.carouselRef = _react.default.createRef();
  }

  render() {
    const _this$props = this.props,
          controls = _this$props.controls,
          showPrevNextControls = _this$props.showPrevNextControls,
          InjectedControls = _this$props.InjectedControls,
          other = _objectWithoutProperties(_this$props, ["controls", "showPrevNextControls", "InjectedControls"]);

    return _react.default.createElement("div", {
      className: "carousel-wrapper"
    }, _react.default.createElement(_reactBootstrap.Carousel, _extends({
      ref: this.carouselRef,
      controls: showPrevNextControls
    }, other), this.props.children), !!controls && _react.default.createElement("div", {
      className: "carousel-controls"
    }, _react.default.createElement("button", {
      id: "playButton",
      onClick: this.handlePlay
    }, "Play"), _react.default.createElement("button", {
      id: "pauseButton",
      onClick: this.handlePause
    }, "Pause")), InjectedControls ? _react.default.createElement(_react.default.Fragment, null, InjectedControls) : null);
  }

}

exports.Carousel = Carousel;
Carousel.propTypes = {
  children: _propTypes.default.node,
  controls: _propTypes.default.bool,
  showPrevNextControls: _propTypes.default.bool,
  InjectedControls: _propTypes.default.element
};
Carousel.defaultProps = {
  children: null,
  controls: true,
  showPrevNextControls: true,
  InjectedControls: null
};
Carousel.Caption = _reactBootstrap.Carousel.Caption;
Carousel.Item = _reactBootstrap.Carousel.Item;

const Select = _react.default.forwardRef((props, ref) => _react.default.createElement(_reactBootstrap.FormControl, _extends({}, props, {
  componentClass: "select",
  ref: ref
})));

exports.Select = Select;

const TextArea = _react.default.forwardRef((props, ref) => _react.default.createElement(_reactBootstrap.FormControl, _extends({}, props, {
  componentClass: "textarea",
  ref: ref
})));

exports.TextArea = TextArea;

/***/ })

/******/ })});;
